// export const apiUrl = "https://villaline2.azurewebsites.net";

export const awsConfig = {
    URL: "https://pxa8yt7750.execute-api.ap-southeast-1.amazonaws.com/Prod",
};